import { LocalStorageKeys } from '@containers/App';
import {
  faArrowAltCircleRight,
  faCheckCircle,
  faClock,
  faFileUpload,
  faTimesCircle,
  faExclamationTriangle,
  faChevronCircleRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon, FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TicketStatus } from '@interfaces/ticket-status';
import { Routes } from '@src/helpers/_routes';
import { StatusProcess } from '@src/helpers/Enums';
import { Avatar, Button, DatePicker, Modal, Popover, Radio, Table, Spin } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import I18n from '../i18n';
import AppContext from '../services/Context';
import styled, { Theme } from '../styled-components';
import verifyItemPermission from '@helpers/verifyItemPermission'
import LinkButtonWithRouter from './MyProcesses/LinkButton';

export interface ITableColumn {
  title: string
  dataIndex: string
  key: string,
  width?: any, //TODO: type
  isHidden?: boolean
}

type PropType = {
  showConfirmationModal: boolean;
  columns: ITableColumn[];
  data: any[];
  onEdit?: any;
  onDownload?: any;
  onUpload?: any;
  downloadLink?: string;
  onVisualize?: any,
  onDelete?: any;
  onActive?: any;
  onTranslate?: any;
  onUnlink?: any;
  onShowMore?: any;
  onFiled?: any;
  onLink?: any
  actionDeleteText?: string;
  customModalTitle?: string;
  type?: any;
  noPagination?: boolean;
  rowSelection?: any;
  onSelectRow?: any;
  scroll?: {
    x?: number | true,
    y?: number
  }
  size?: "small" | "middle" | "default" | undefined;
  hideDeleteButtonClass?: string;
  className?: string
  disabledLoading?: boolean;
  url?: boolean;
  status?: boolean;
  descriptionDelete?: string;
  labelDelete?: string;
  popoverContent?: any;
  visiblePopover?: boolean;
  handleVisiblePopover?: any
  onClickPopover?: any;
  editDeadline?: any;
  editPermission?: string,
  deletePermission?: string,
  createPermission?: string,
  pillar?: any,
  isUser?: boolean,
  isGroup?: boolean,
  onExec?: any,
  loadScheduled?: Function,
  loadUnscheduled?: Function,
  processType: string,
  onDuplicate?: any,
  isDuplicating?: boolean,
  isDashboard?: boolean
};

type StateType = {
  showConfirmationModal: boolean;
  toDelete?: string;
  deadline: any;
  overdue?: number;
  visiblePopover: boolean;
};

const confirm = Modal.confirm;

function showDeleteConfirm(title: string, description: string, deletebtn: string, cancelbtn: string, onDelete: any, toDelete: any) {
  confirm({
    title,
    content: description,
    okText: deletebtn,
    okType: 'primary',
    cancelText: cancelbtn,
    onOk() {
      onDelete(toDelete)
    },
    onCancel() {
      console.log('Cancel');
    },
  });
}



export default class TableComponent extends React.Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props);

    this.state = {
      showConfirmationModal: false,
      toDelete: '',
      deadline: undefined,
      visiblePopover: false
    }
  }

  toggleConfirmationModal = (toDelete?: string) =>
    this.setState({
      showConfirmationModal: !this.state.showConfirmationModal,
      toDelete,
    });

  popoverContent(item: any) {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return (
      <>
        <Radio.Group key={item.id} defaultValue={item.overdueAt ? 1 : 0} style={{ width: '20%' }} onChange={this.handleDeadlineRadio}>
          <Radio style={radioStyle} value={0}>{I18n.l('label.withoutDeadline')}</Radio>
          <Radio style={radioStyle} value={1}>{I18n.l('label.deadline')}</Radio>
        </Radio.Group>
        {/* {(item.overdueAt) && */}
        <>
          <div>
            <AppContext.Consumer>
              {({ locale }) => (
                <DatePicker
                  format={I18n.l('common.dateFormat')}
                  defaultValue={item.overdueAt ? moment(item.overdueAt) : undefined}
                  locale={(locale === "pt-BR") ? pt_BR.DatePicker : undefined}
                  showTime={true}
                  onOk={this.handleDateDeadline}
                  showToday={false}
                  disabledDate={this.disabledDate}
                />
              )}
            </AppContext.Consumer>
          </div>
        </>
        {/* } */}
      </>
    )
  }

  disabledDate(current: any) {
    return current && current < moment().endOf('day');
  }


  handleVisiblePopover = async (visible: any) => {
    this.setState({ visiblePopover: visible })
  }

  handleDeadlineRadio = async (evt: any) => {
    this.setState({ deadline: evt.target.value })
    this.props.editDeadline(this.state.overdue, this.state.deadline)
  }
  handleDateDeadline = async (date: any) => {
    const newDate = date.toDate().getTime()
    this.setState({ deadline: 1, overdue: newDate })
    this.props.editDeadline(this.state.overdue, this.state.deadline)

  }


  render() {
    const {
      columns,
      data,
      onEdit,
      onDownload,
      onVisualize,
      onTranslate,
      onDelete,
      onActive,
      onUnlink,
      actionDeleteText,
      customModalTitle,
      onShowMore,
      noPagination = false,
      rowSelection,
      onSelectRow,
      scroll,
      size,
      className,
      onUpload,
      onFiled,
      onLink,
      editPermission,
      deletePermission,
      createPermission,
      pillar,
      isUser,
      isGroup,
      onExec,
      processType,
      loadScheduled,
      loadUnscheduled,
      onDuplicate,
      isDuplicating,
      isDashboard
    } = this.props;

    const groupsPermissionKey = isUser ? 'group' : (isDashboard ? 'groupId' : 'groupsPermission')
    const createdByKey = isGroup ? 'created_by' : 'createdBy'

    return (
      <Wrapper>
        <Table className={className}
          pagination={false}
          rowSelection={rowSelection}
          size={size != undefined ? size : "default"}
          scroll={scroll}
          rowClassName={(rec: any, i: any) => rec.statusRAW && rec.statusRAW === 5 ? 'overdue' : ''}
          onRow={(record) => ({
            onClick: () => {
              !!onSelectRow ? onSelectRow(record) : null;
            },
          })}
          columns={
            columns.filter((column: ITableColumn) => !column.isHidden).map(column => {
              return {
                title: I18n.l(column.title),
                dataIndex: column.dataIndex,
                key: !!column.key ? String(column.key) : Date.now().toString(),
                width: column.width,
              }
            })
          } dataSource={
            data.map((item, i) => {
              const obj = {}
              const action = _.find(columns, (i: any) => { return i.key === 'action' }) || false;
              Object.keys(item).map((key) => {
                if (item.disabled) {
                  obj[key] = <span className="disabled">{item[key]}</span>;
                } else {
                  if (key === 'name' && item.tags) {
                    obj[key] = <span>
                      {item[key]}
                      {Object.keys(item.tags).map((r, index) => <>
                        <br key={`br-${index}`} />
                        <strong key={index}>{I18n.l(`tags.${r}`)}:</strong> {item.tags[r]}
                      </>)}
                    </span>
                  } else {
                    obj[key] = item[key];
                  }
                }
                if (item.label) {
                  const userId = String(localStorage.getItem(LocalStorageKeys.USER_ID))
                  let ownersId: string[] = []
                  if (item && item.owners) {
                    for (let owner of item.owners) {
                      ownersId.push(owner.id)
                    }
                  }
                  // const owners = item.owners.find((e:any) => e.id === userId )
                  if (this.props.url && item.status !== StatusProcess.DONE && ownersId.includes(userId)) {

                    obj['label'] =
                      <>
                        <a>
                          <Link to={`${Routes.executionprocess}/${item.ticketId}/process/${item.processId}`} >
                            {item.label}
                          </Link>
                        </a>
                      </>
                  }
                  else {
                    obj['label'] = <span>{item.label} </span>
                  }

                }
                if (item.owners) {
                  const ownersNames: any[] = []
                  for (let [index, owner] of item.owners.entries()) {
                    ownersNames.push(
                      <div>{owner.name}</div>
                    )
                  }
                  obj['owners'] = ownersNames
                }
                if (item.statusWarning) {
                  if (item.statusWarning == true)
                    obj['statusWarning'] = <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" />
                }
                if (item.url) {
                  let content;
                  if (item.url != undefined && item.url != '-') {
                    content = <Avatar shape="square" size="large" src={item.url} />
                  }
                  else {
                    content = <span className="goepik-big-left-margin">-</span>
                  }
                  obj['url'] = content;
                }

                if (item.photo) {
                  let content;
                  if (item.photo != undefined && item.photo != '-') {
                    content = <Avatar shape="square" size="large" src={item.photo} />
                  }
                  else {
                    content = <span className="goepik-big-left-margin">-</span>
                  }
                  obj['photo'] = content;
                }
                if (item.startAt) {
                  if (item.startAt === '-') {
                    obj['startAt'] = ''
                  }
                  else {
                    const startAt = new Date(item.startAt);
                    const startAtFormated = moment(startAt).format(I18n.l('common.dateTimeFormat'))
                    const newStartAt = startAtFormated.split(' ')
                    if (item.disabled) {
                      obj['startAt'] = <span className="disabled">{moment(startAt).format(I18n.l('common.dateFormat'))}</span>
                    } else {
                      obj['startAt'] =
                        <>
                          <div>
                            {newStartAt[0]}
                          </div>
                          <div className='time-style'>
                            {newStartAt[1]}
                          </div>
                        </>
                    }
                  }
                }

                if (item.modifiedAt) {
                  const modifiedAt = new Date(item.modifiedAt);
                  const modifiedAtFormated = moment(modifiedAt).format(I18n.l('common.dateTimeFormat'))
                  const newmodifiedAt = modifiedAtFormated.split(' ')
                  if (item.disabled) {
                    obj['modifiedAt'] = <span className="disabled">{moment(item.modifiedAt).format(I18n.l('common.dateFormat'))}</span>
                  } else {
                    obj['modifiedAt'] =
                      <>
                        <div>
                          {newmodifiedAt[0]}
                        </div>
                        <div className='time-style'>
                          {newmodifiedAt[1]}
                        </div>
                      </>
                  }
                }
                if (item.endAt) {
                  const endAt = new Date(item.endAt);
                  const endAtFormated = moment(endAt).format(I18n.l('common.dateTimeFormat'))
                  const newEndAt = endAtFormated.split(' ')
                  if (item.disabled) {
                    obj['endAt'] = <span className="disabled">{moment(item.endAt).format(I18n.l('common.dateFormat'))}</span>
                  } else {
                    obj['endAt'] =
                      <>
                        <div>
                          {newEndAt[0]}
                        </div>
                        <div className='time-style'>
                          {newEndAt[1]}
                        </div>
                      </>
                  }
                }
                if (item.createdAt) {
                  const createdAt = new Date(item.createdAt);
                  const createdAtFormated = moment(createdAt).format(I18n.l('common.dateTimeFormat'))
                  const newcreatedAt = createdAtFormated.split(' ')
                  if (item.disabled) {
                    obj['createdAt'] = <span className="disabled">{moment(createdAt).format(I18n.l('common.dateFormat'))}</span>
                  } else {
                    obj['createdAt'] =
                      <>
                        <div>
                          {newcreatedAt[0]}
                        </div>
                        <div className='time-style'>
                          {newcreatedAt[1]}
                        </div>
                      </>
                  }
                }
                if (item.overdueAt) {
                  const overdueAt = new Date(item.overdueAt);
                  const overdueAtFormated = moment(overdueAt).format(I18n.l('common.dateTimeFormat'))
                  const newoverdueAt = overdueAtFormated.split(' ')
                  if (item.disabled) {
                    obj['overdueAt'] = <span className="disabled">{moment(overdueAt).format(I18n.l('common.dateFormat'))}</span>
                  } else {
                    obj['overdueAt'] =
                      <>
                        <div>
                          {newoverdueAt[0]}
                          <Popover
                            key={item.id}
                            placement="right"
                            content={this.popoverContent(item)}
                            trigger="click"
                            style={{ position: 'relative' }}
                          >
                            <span onClick={() => this.props.onClickPopover(item)}>
                              <FontAwesomeIcon style={{ marginLeft: '10px' }} icon='ellipsis-h' />
                            </span>
                          </Popover>
                        </div>
                      </>
                  }
                }
                else {
                  obj['overdueAt'] = <div>
                    {I18n.l('label.withoutDeadline')}
                    <Popover
                      key={item.id}
                      placement="right"
                      content={this.popoverContent(item)}
                      trigger="click"
                    >
                      <span onClick={() => this.props.onClickPopover(item)}>
                        <FontAwesomeIcon style={{ marginLeft: '10px' }} icon='ellipsis-h' />
                      </span>
                    </Popover>
                  </div>
                }
                const statusTicket = (status: any) => {
                  switch (status) {
                    case TicketStatus.OPENED:
                      return (
                        <span>
                          {I18n.l('processManagement.description.status')}
                        </span>
                      )
                    case TicketStatus.IN_PROGRESS:
                      return (
                        <div style={{ color: '#E98513' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faArrowAltCircleRight} />
                          <span>{I18n.l('global.taskflow.status.inprogress')}</span>
                        </div>
                      );
                    case TicketStatus.CLOSED:
                      return (
                        <span style={{ color: '#038119' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faCheckCircle} />
                          {I18n.l('dashboard.dones')}
                        </span>
                      );
                    case TicketStatus.CANCELED:
                      return (
                        <span style={{ color: 'red' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faTimesCircle} />
                          {I18n.l('common.error')}
                        </span>
                      );
                    default:
                      return I18n.l('processManagement.description.status');
                  }
                }
                const statusProcess = (status: any) => {
                  switch (status) {
                    case StatusProcess.PENDENT:
                      return (
                        <span style={{ color: `${Theme.secondary.grey}` }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faClock} />
                          {I18n.l('processManagement.description.status')}
                        </span>
                      )
                    case StatusProcess.IN_PROGRESS:
                      return (
                        <div style={{ color: '#E98513' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faArrowAltCircleRight} />
                          <span>{I18n.l('global.taskflow.status.inprogress')}</span>
                        </div>
                      );
                    case StatusProcess.DONE:
                      return (
                        <span style={{ color: '#038119' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faCheckCircle} />
                          {I18n.l('dashboard.dones')}
                        </span>
                      );
                    case StatusProcess.ERROR:
                      return (
                        <span style={{ color: 'red' }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faTimesCircle} />
                          {I18n.l('common.error')}
                        </span>
                      );

                    case StatusProcess.OVERDUE:
                      return (
                        <span className="overdue-label">
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faExclamationTriangle} />
                          {I18n.l('statusprocess.overdue')} {item.to}
                        </span>
                      )
                    case StatusProcess.WAIT:
                      return (
                        <span style={{ color: `${Theme.secondary.grey}` }}>
                          <Icon style={{ paddingRight: '5px', paddingTop: '8px', fontSize: '24px' }} icon={faChevronCircleRight} />
                          {I18n.l('statusprocess.available')}
                        </span>
                      )
                    default:
                      return I18n.l('processManagement.description.status');
                  }
                }
                if (item.status && this.props.status) {
                  obj['status'] = statusProcess(item.status)
                  obj['statusRAW'] = item.status
                }
                if (item.status && !this.props.status) {
                  obj['status'] = statusTicket(item.status)
                }

                if (action && !(item.actionDisabled && item.actionDisabled == true)) {
                  const DeleteText = actionDeleteText ? actionDeleteText : I18n.l('common.delete')
                  obj['action'] =
                    (<span className='action-buttons'>
                      {onEdit && (editPermission && (pillar && pillar === 'LI') ? verifyItemPermission(item[groupsPermissionKey], editPermission, item[createdByKey], true) : true) && (
                        <Button type="primary" ghost onClick={() => onEdit(item)}>{I18n.l('common.edit')}</Button>
                      )}

                      {onLink && (
                        <Button disabled={item.status !== StatusProcess.DONE ? false : true} type="primary" ghost onClick={() => onLink(item)}>{I18n.l('common.transfer')}</Button>
                      )}
                      {onDownload && (createPermission && (pillar && pillar === 'LI') ? verifyItemPermission(item[groupsPermissionKey], createPermission, item[createdByKey]) : true) && (
                        <Button
                          type="primary"
                          ghost
                          onClick={() => onDownload(item)}
                          target='_blank'
                        >
                          {I18n.l('formflow.components.download')}
                        </Button>
                      )}

                      {onUpload && (
                        <Button
                          onClick={() => onUpload(item)}
                          size="small"
                          className="goepik-btn-main"
                        >
                          <Icon icon={faFileUpload} />
                        </Button>
                      )}
                      {onVisualize && (
                        <Button type="primary" ghost onClick={() => onVisualize(item)}>{I18n.l('common.visualize')}</Button>
                      )}
                      {onTranslate && (
                        <Button disabled={item.langs.length === 0} type="primary" ghost onClick={() => onTranslate(item, i)}>{I18n.l('common.translate')}</Button>
                      )}
                      {onDelete && (deletePermission && (pillar && pillar === 'LI') ? verifyItemPermission(item[groupsPermissionKey], deletePermission, item[createdByKey]) : true) && (
                        <Button className={this.props.hideDeleteButtonClass} disabled={this.props.disabledLoading ? true : item.canBeDisabled === false} type="danger" ghost onClick={() => showDeleteConfirm(
                          this.props.labelDelete ? this.props.labelDelete : I18n.l('titles.confirmDelete'),
                          this.props.descriptionDelete ? this.props.descriptionDelete : I18n.l('titles.descconfirmDelete'),
                          I18n.l('common.delete'),
                          I18n.l('common.cancel'),
                          onDelete,
                          item.id
                        )}>{this.props.labelDelete ? this.props.labelDelete : I18n.l('common.delete')}</Button>
                      )}
                      {onActive && (editPermission && (pillar && pillar === 'LI') ? verifyItemPermission(item[groupsPermissionKey], editPermission, item[createdByKey]) : true) && (
                        <Button disabled={!item.canBeDisabled} type={(item.disabled) ? 'primary' : 'danger'} ghost onClick={() => (item.disabled) ? onActive(true, item.id) : onActive(false, item.id)}>
                          {(item.disabled) ? I18n.l('common.enable') : I18n.l('common.disable')}
                        </Button>
                      )}

                      {onFiled && (deletePermission && (pillar && pillar === 'LI') ? verifyItemPermission(item[groupsPermissionKey], deletePermission, item[createdByKey]) : true) && (
                        <Button type={(item.disabled) ? 'primary' : 'danger'} disabled={this.props.disabledLoading ? true : false} ghost onClick={() => (item.disable) ? onFiled(true, item.id) : onFiled(false, item.id)}>
                          {(item.disable) ? I18n.l('common.unfiled') : I18n.l('common.filed')}
                        </Button>
                      )}
                      {onUnlink && (
                        <Button type="danger" ghost onClick={() =>
                          showDeleteConfirm(
                            customModalTitle ? customModalTitle : I18n.l('titles.confirmDelete'),
                            I18n.l('titles.unlinkAuditorActionContent'),
                            I18n.l('common.unlink'),
                            I18n.l('common.cancel'),
                            onUnlink,
                            item.id
                          )}
                        >{DeleteText}</Button>
                      )}

                      {onExec && (
                        <LinkButtonWithRouter
                          route={{ pathname: `${Routes.executionprocess}/newProcessExecution`, state: { newWorkflow: true, process: onExec(item.id), tags: item.tags || null } }}
                          ticket={LocalStorageKeys.TICKETID}
                          item={item}
                          processType={processType}
                          loadScheduled={loadScheduled}
                          loadUnscheduled={loadUnscheduled}
                        >
                          {I18n.l('common.start')}
                        </LinkButtonWithRouter>
                      )}

                      {onDuplicate && (<>
                        {isDuplicating && <Spin size="small" />}
                        <Button
                          type="danger"
                          ghost
                          onClick={() => onDuplicate(item)}
                          disabled={isDuplicating}
                        >
                          {I18n.l('common.duplicate')}
                        </Button>
                      </>)}
                    </span>
                    )
                }
              })
              obj['key'] = item.id || i
              return obj;
            })
          } bordered={false} />
        {!noPagination && (
          <ButtonWrapper>
            <Button className="link primary" onClick={onShowMore}>
              {I18n.l('table.moreData')}
            </Button>
          </ButtonWrapper>
        )}
      </Wrapper>
    );
  }
}


const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow-x: auto;
    .table-title-big{
        font-weight: bold; !important;  
        background: #ff0;
        font-size: 22px;
    }
    
    .ant-table-thead{
        overflow: hidden;
        font-weight: bold;
        background: #ff0;
        font-size: 17px;
    }   

    .ant-table-wrapper {
        button {
            border: 0;
        }
    }

    .action-buttons {
        text-align: right;
        button {
            margin: 0 0 3px 0px;
            text-align: left;
            box-shadow: 10px;
            padding: 0;
            span {
                padding: 0 9px 0 9px;
            }
        }
        button:not(:last-child) {
            span {
                border-right: .5px solid #e8e8e8;
            }
        }
    }

    table {
        th{
            position: relative;
            background-color: #fff;
        }
        td {
            .disabled {
                color: #ccc;
            }
        }
        tr:last-child > td {
            border-bottom: 0;
          }
    }

    .goepik-btn-main,
    .goepik-btn-main:hover,
    .goepik-btn-main:focus {
      font-weight: bold;
      text-transform: uppercase;
      border: none;
      color: $primary-btn-color;
      background: transparent;
      height: unset;
      font-size: 30px;
  }
  .time-style {
     color: ${Theme.secondary.midGrey};
     font-weight: bold;
  }
`;

const ButtonWrapper = styled.div`
    padding-top: 25px;
    button {
        font-size: 1.1em;
    }
`;
